import React from "react";
import FullScreenDialog from "../../../common/FullScreenDialog";
import KeyHandoverBookingPage from "../pages/KeyHandoverBookingPage";
import { KeyHandoverProvider } from "../context/KeyHandoverContext";

interface KeyHandoverBookingDialogProps {
  open: boolean;
  locationId?: string;
}

const KeyHandoverBookingDialog = (props: KeyHandoverBookingDialogProps) => {
  return (
    <FullScreenDialog open={props.open}>
      <KeyHandoverProvider>
        <KeyHandoverBookingPage />
      </KeyHandoverProvider>
    </FullScreenDialog>
  );
};

export { KeyHandoverBookingDialog };
